











import Vue, { PropOptions } from 'vue';

interface ProductSalesPageIncludedContentProps {
  value: PropOptions;
}

export default Vue.extend({
  name: 'ProductSalesPageIncludedContent',
  props: {
    value: {
      type: Object as () => ProductSalesPageIncludedContentResponse,
    },
  } as ProductSalesPageIncludedContentProps,
  methods: {
    handleOnInput(key: string, value: any): void {
      const emitData = {
        ...this.value,
        [key]: value,
      };
      this.$emit('input', emitData);
    },
  },
});
